module.exports = __webpack_public_path__ + "img/oris.59cffea0.svg";